module.exports = __webpack_public_path__ + "img/p2.2a01dd89.png";